import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeEntityScaffold } from '@classpass/saga-tools';
var FILTERS_TIMEOUT = 5000; // Default timeout for Filters API, as a temporary measure while core cause for timeouts is investigated.

export var filtersByHash = makeEntityScaffold('SAGA.API.FILTERS_BY_HASH', function (client, hash, overrides) {
  return client.filters.getByHash(hash, null, _objectSpread({
    timeout: FILTERS_TIMEOUT
  }, overrides)) // has URL params, second argument is query params, third is overrides.
  .then(function (data) {
    return data.data;
  });
}, {
  defaultKey: 1
});
export var filtersByQuery = makeEntityScaffold('SAGA.API.FILTERS_BY_QUERY', function (client, params, overrides) {
  return client.filters.getByQuery(params, _objectSpread({
    timeout: FILTERS_TIMEOUT
  }, overrides)) // has no URL params, second argument is overrides.
  .then(function (data) {
    return data.data;
  });
});
export var relatedFiltersByHash = makeEntityScaffold('SAGA.API.RELATED_FILTERS_BY_HASH', function (client, hash, overrides) {
  return client.filters.getRelatedByHash(hash, null, _objectSpread({
    timeout: FILTERS_TIMEOUT
  }, overrides)).then(function (data) {
    return data.data;
  }).then(function (data) {
    return data.groups;
  }).then(function (groups) {
    return groups.filter(function (group) {
      return group.filters && group.filters.length;
    });
  });
}, {
  defaultKey: 1
});